import { render, staticRenderFns } from "./_base.vue?vue&type=template&id=593ee79e&scoped=true"
import script from "./_base.vue?vue&type=script&lang=js"
export * from "./_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ee79e",
  null
  
)

export default component.exports